import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLinkExternalAccount = () => {
    const send = useGenericSend();

    return useCallback(async ({ type, identityToken }: Types.ILinkExternalAccountRequestData) => {
        const { data } = await send<Types.ILinkExternalAccountRequestData, Types.ILinkExternalAccountResponseData>({
            ID: 35957,
            type,
            identityToken,
            description: 'Link external account',
            responses: [35958, 35959]
        });

        return data;
    }, [send]);
};
